export enum MaintenanceReminderStatus {
    Incoming = "Incoming",
    Approaching = "Approaching",
    Exceeded = "Exceeded",
    AwaitingApproval = "AwaitingApproval",
    Completed = "Completed",
}

export interface VehicleMaintenanceReminderDto {
    id: string;
    ownerId: string;
    vehicleMaintenanceId: string;
    status: MaintenanceReminderStatus;
    remindByDate: boolean;
    remindByOdometerReading: boolean;
    datesBeforeReminderStarts?: number;
    odometerReadingForMaintenance?: number;
    distanceBeforeReminderStarts?: number;
    createdAt: string;
    modifiedAt: string;
    modifiedEmployeeId?: string;
    reminderDate?: string | null;
}
